import React from "react";
import { BotNAcciN } from "../../components/BotNAcciN";
import { InputContraseA } from "../../components/InputContraseA";
import { StateDefaultWrapper } from "../../components/StateDefaultWrapper";
import { InputCode } from "../../components/InputCode";
import "./style.css";
import { CognitoUser, CognitoUserPool, AuthenticationDetails } from 'amazon-cognito-identity-js';
import QR from "qrcode"
import AWS from 'aws-sdk';
import { useState } from 'react';
import { resetPassword } from 'aws-amplify/auth';
import { confirmResetPassword } from 'aws-amplify/auth';
import { Amplify} from 'aws-amplify';
import config from '../../amplifyconfiguration.json';
import awsconfig from '../../aws-exports';
import {signOut, getCurrentUser, confirmSignIn, signIn} from 'aws-amplify/auth';




export const LoginClear = ({updateState}) => {

  AWS.config.region = 'us-east-1';
  Amplify.configure(awsconfig);
  

  const [username, setUser] = useState('');
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState('signIn'); // "signIn" | "confirmMFA"

  const handleUserInputChange = (username) => {
    setUser(username);
  };

  const [password, setPassword] = useState('');

  const handlePasswordInputChange = (password) => {
    setPassword(password);
  };

  const [otpCode, setMFACode] = useState('');
  
  const handleMFAInputChange = (mfacode) => {
    setMFACode(mfacode);
  };

      

  const handleSignIn = async (username, password) => {
                      try{

                          const {

                            username,

                            signInDetails

                          } = await getCurrentUser();
                          await signOut();
                      } catch (error) { 

                      }
                      
                      console.log('holaaaaaa')
                      try {

        
                        /*const {

                          isSignedIn,

                          nextStep

                        } = await signIn({ username, password,   options: {
                                              authFlowType: 'USER_AUTH',
                                              preferredChallenge: "EMAIL_OTP"
                                          }
                                        });

*/
                        const {isSignedIn, nextStep} = await signIn({ username, password,   options: {
                                              authFlowType: 'USER_PASSWORD_AUTH'
                                          }
                                        });
                        

                        switch (nextStep.signInStep) {

                          case 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED':

                            
                            //const newPassword = 'nueva password';
                            
                            const newPassword = '';
                            const {

                              isSignedIn,

                              nextStep

                            } = await confirmSignIn({

                              challengeResponse: newPassword

                            });
                            console.log("New Password Required");

                            break;

                          case 'CONFIRM_SIGN_IN_WITH_SMS_CODE':
                            console.log("Login con SMS MFA");
                            setStep('confirmMFA');
                            break;

                          case 'CONFIRM_SIGN_IN_WITH_EMAIL_CODE':
                            console.log("Login con email MFA");
                            setStep('confirmMFA');
                            break;

                          case 'DONE':

                            console.log("Login existoso!!!");
                            await updateState();

                        }

                      } catch (error) { 
                        console.log(error)
                      }

                      

            }

  async function handleSignInConfirmation(otpCode) {
    try {
      await confirmSignIn({ challengeResponse: otpCode });
      updateState();
    } catch (error) {
      console.log(error);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (step === 'signIn'){
      setLoading(true);
      await handleSignIn(username, password);
      setLoading(false);
      //await signIn(username, password);
    }else{
      setLoading(true);
      await handleSignInConfirmation(otpCode);
    } // "signIn" | "confirmMFA"

  };
   
  return (
    
    <div className="login-clear">
    {loading ? (
        <div className="loading-div">
          <img className="loading" src="/img/loading.gif" alt="Cargando..." />
        </div >
        ) : null}
      <div className="logo-container">
        <img className="background" alt="Background" src="/img/background.png" />
        {/*<img className="holding-viewer-logo" alt="holding-viewer-logo" src="/img/holding-viewer-logo.png" />*/}
        <div className="segmentatio-logo">
          <div className="group">
            <div className="isolation-mode">
              <div className="group">
                <div className="overlap">
                  <div className="overlap-group-wrapper">
                    <div className="overlap-group">
                      <div className="group-2" />
                      </div>
                    </div>
                    <div className="overlap-wrapper">
                      <div className="overlap-2">
                        <div className="group-3" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        {step == 'signIn' ?
        (<div className="bloque-inicio-sesin">
          <div className="text-wrapper">Iniciar sesión</div>
          <div className="info-input">
            <InputContraseA
              onInputChange = {handleUserInputChange} 
              className="input-contrasea"
              iconPerson="/img/icon-person-2.png"
              stateProp="default"
              text="Usuario"
            />
            <StateDefaultWrapper
              onInputChange = {handlePasswordInputChange}
              className="input-contrasea"
              iconPerson="/img/icon-person-1.png"
              stateProp="default"
              text="Contraseña"
            />
          </div>
          <BotNAcciN className="botn-accin" text="Ingresar" onClick={handleSubmit}/>
      </div>
      ):
        (
          <div className="bloque-inicio-sesin">
          <div className="text-wrapper-mfa">Código de autenticación requerido</div>
          <div className="label">
            <p className="text-wrapper">Enviamos un código de 6 dígitos a tu e-mail. Ingrésalo en la parte inferior para verificar tu identidad e iniciar sesión:</p>
          </div>
          <div className="info-input">
            <InputCode
              onInputChange = {handleMFAInputChange} 
              className="input-contrasea"
              iconPerson="/img/icon-person-2.png"
              stateProp="default"
              text="Ingresar código de verificación"
            />
          </div>
          <BotNAcciN className="botn-accin" text="Ingresar" onClick={handleSubmit}/>
        </div>
        )
    }
    </div>
  );
};
